import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  dialogTitle: {
    color: theme.palette.blue_300.main
  },
  fileDescription: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    marginTop: '8px',
    fontSize: '.8rem'
  }
}))
